[
  {
    "url": "https://www.linkedin.com/sales/lead/",
    "elements": [
      {
        "name": "Full Name",
        "selector": "h1[data-anonymize='person-name']"
      },
      {
        "name": "Company Names",
        "selector": "#profile-card-section p[class^='_current-role'] a[data-anonymize='company-name']",
        "attributes": ["href"],
        "multiple": "true",
        "keepEmpty": "true"
      },
      {
        "name": "Company Names No Link",
        "selector": "#profile-card-section p[class^='_current-role'] span[data-anonymize='company-name']",
        "multiple": "true"
      },
      {
        "name": "Title",
        "selector": "#profile-card-section span[data-anonymize='job-title']"
      },
      {
        "name": "Location",
        "selector": "#profile-card-section section > div > div:nth-child(4) > div"
      },
      {
        "name": "Linkedin URL",
        "scenario": {
          "name": "collectDropdownItem",
          "params": {
            "triggerSelector": "#profile-card-section button[id^='hue-menu-trigger-ember']",
            "itemSelector": "a[href*='linkedin.com/in/']"
          }
        },
        "attributes": ["href"],
        "once": "true"
      }
    ]
  },
  {
    "url": "https://www.linkedin.com/sales/company/",
    "elements": [
      {
        "name": "Company Website",
        "selector": "#account [data-control-name='visit_company_website']",
        "attributes": ["href"]
      }
    ]
  },
  {
    "url": "https://www.linkedin.com/sales/search/people",
    "elements": [
      {
        "name": "Search names",
        "selector": "#search-results-container ol.artdeco-list > li a[href^='/sales/lead/'][data-lead-search-result^='profile-link']",
        "attributes": ["href"],
        "multiple": "true",
        "keepEmpty": "true"
      },
      {
        "name": "Search positions",
        "selector": "span[data-anonymize='title']",
        "multiple": "true",
        "within": "#search-results-container ol.artdeco-list > li .artdeco-entity-lockup__subtitle",
        "keepEmpty": "true"
      },
      {
        "name": "Search locations",
        "selector": "#search-results-container span[data-anonymize='location']",
        "multiple": "true",
        "keepEmpty": "true"
      },
      {
        "name": "Search companies",
        "selector": "[data-anonymize='company-name']",
        "multiple": "true",
        "attributes": ["href"],
        "within": "#search-results-container ol.artdeco-list > li .artdeco-entity-lockup__content",
        "keepEmpty": "true"
      },
      {
        "name": "Search summaries",
        "selector": "div.artdeco-entity-lockup__subtitle",
        "multiple": "true",
        "within": "#search-results-container ol.artdeco-list > li .artdeco-entity-lockup__content",
        "keepEmpty": "true"
      },
      {
        "name": "Results count",
        "selector": "main > div > div:nth-child(2) > div > div:nth-child(2) > div > div:nth-child(5) > span"
      }
    ]
  },
  {
    "url": "https://www.linkedin.com/sales/lists/people/",
    "elements": [
      {
        "name": "Search names",
        "selector": "a[data-anonymize='person-name']",
        "attributes": ["href"],
        "multiple": "true",
        "keepEmpty": "true"
      },
      {
        "name": "Search positions",
        "selector": "div[data-anonymize='job-title']",
        "multiple": "true",
        "keepEmpty": "true"
      },
      {
        "name": "Search locations",
        "selector": "table td[data-anonymize='location']",
        "multiple": "true",
        "keepEmpty": "true"
      },
      {
        "name": "Search companies",
        "selector": "div.company-entity a",
        "multiple": "true",
        "attributes": ["href"],
        "keepEmpty": "true"
      }
    ]
  }
]
